import { zodResolver } from '@hookform/resolvers/zod';
import { Disc3 } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import Error from '@/components/common/Error';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot
} from '@/components/ui/input-otp';

import { usePostUserLoginWithCode } from '@/data/user';

const formSchema = z.object({
  verificationCode: z.string().min(6, {
    message: 'Your verification code must be 6 characters.'
  })
});

const VerifyGuestForm = ({ email, onSuccess }) => {
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const postUserLoginWithCode = usePostUserLoginWithCode();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      verificationCode: ''
    }
  });

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      setApiError('');
      const payload = {
        ...values,
        email
      };
      // Login the user with the verification code
      await postUserLoginWithCode(payload);

      // Link the user to the cart
      await onSuccess();
    } catch (error) {
      setApiError('Code incorrect or expired. Try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="verificationCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Verification Code</FormLabel>
              <FormControl>
                <InputOTP maxLength={6} {...field}>
                  <InputOTPGroup className="text-2xl">
                    <InputOTPSlot index={0} className="w-14 h-14 text-2xl" />
                    <InputOTPSlot index={1} className="w-14 h-14 text-2xl" />
                    <InputOTPSlot index={2} className="w-14 h-14 text-2xl" />
                    <InputOTPSlot index={3} className="w-14 h-14 text-2xl" />
                    <InputOTPSlot index={4} className="w-14 h-14 text-2xl" />
                    <InputOTPSlot index={5} className="w-14 h-14 text-2xl" />
                  </InputOTPGroup>
                </InputOTP>
              </FormControl>
              <FormDescription>
                Please enter the verification code sent to your email. The code
                will expire in 15 minutes.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        {apiError && <Error error={apiError} />}
        <div className="flex justify-end">
          <Button type="submit" disabled={submitting}>
            {submitting && <Disc3 className="animate-spin" />}
            Submit
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default VerifyGuestForm;
